<template>
  <div class="et-tabox">
    <div class="form">
      <div v-for="(item,ind) in RegistrationForm">
        <!--text文本-->
        <div class="group" v-if="item.field_type == 'text'">
          <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>

          <div class="et-typebox et-typeText">
            <input class="form-control" :is_require="item.is_require" :type="item.field_type" :name="item.name"
                   :placeholder="item.tip" @focus="SmallFocus(ind)"
                   @keyup="SmallKeyup($event,item.rule_type,item.is_require)" @blur="SmallBlur(ind)"
                   :value="item.default_value"/>
            <p class="prompt" style="  font-size: 14px;color: #C8494E;line-height: 25px;display: none">
              请输入正确的{{item.title}}格式！</p>
            <i class="icon-delete" @click="SmallDelete(ind)"></i>
          </div>
        </div>
        <!--多行文本-->
        <div class="group" v-if="item.field_type == 'textarea'">
          <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>

          <div class="et-trbox">
              <textarea class="form-control" rows="3" :is_require="item.is_require" :name="item.name"
                        :placeholder="item.tip" :value="item.default_value"></textarea>
            <i class="icon-delete" @click="largeDelete"></i>
          </div>
        </div>
        <!--单选-->
        <div class="group" v-if="item.field_type == 'radio'">
          <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>
          <ul class="et-radiolink" v-if="JSON.parse(item.option_json)">
            <li v-for="(val,ind) in Math.ceil(JSON.parse(item.option_json).length/2)">
              <div class="et-libox" v-for="(val,i) in 2" v-if="JSON.parse(item.option_json)[ind*2 + i]"
                   @click="sexOn(ind*2 + i,JSON.parse(item.option_json)[ind*2 + i],item.name)">
                <!-- :class="'radio-box'+' '+item.name"-->
                <div
                  :class="JSON.parse(item.option_json)[ind*2 + i] == item.default_value?'radio-box radio-on'+' '+item.name:'radio-box'+' '+item.name"
                  :is_require="item.is_require" :name="item.name">
                  <input :type="item.field_type" :name="item.name"/>
                </div>
                <span>{{JSON.parse(item.option_json)[ind*2 + i]}}</span>
              </div>
            </li>
          </ul>
        </div>
        <!--多选-->
        <div class="group" v-if="item.field_type == 'checkbox'">
          <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>
          <ul class="et-checklink" :is_require="item.is_require" :name="item.name">
            <li v-for="(val,ind) in JSON.parse(item.option_json)">
              <div class="check-box" :attr-name="val">
                <input type="checkbox" :name="item.name"/>
              </div>
              <span>{{val}}</span>
            </li>

          </ul>
        </div>
        <!--下拉框-->
        <div class="group" v-if="item.field_type == 'select'">
          <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>

          <div class="et-slebox form-control">
            <select class="form-control select" :name="item.name" :is_require="item.is_require">
              <option v-for="(val,ind) in JSON.parse(item.option_json)" :value="val">{{val}}</option>
            </select>
            <i class="icon-select"></i>
          </div>
        </div>
        <!--日期-->

        <div class="group" v-if="item.field_type == 'date'">
          <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>

          <div class="et-typebox et-typeData">
            <!--<p class="time-txt">2019-12-12</p>-->
            <!--
            <input class="form-control date-show" type="text" :name="item.name" :is_require="item.is_require"
                   value="2019-12-12"/>
            <input class="form-control date-style" type="date" name="date" value="2017-06-01"/>
            -->
            <input class="form-control date-new-show" type="date"  :name="item.name" :is_require="item.is_require" value=""/>
            <!--<i class="icon-date"></i>-->
          </div>
        </div>
        <!--地区-->
        <div class="group content-block" v-if="item.field_type == 'address'">
          <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>
          <Linkage @message="listenToMyBoy" :text="item.default_value"></Linkage>
          <input class="demo1" :title="item.title" style="display: none" :name="item.name" :is_require="item.is_require"
                 type="text">
          <div class="group detailed" style="display: block">
            <label>详细地址<span v-show="item.is_require == 1">*</span></label>
            <div class="et-typebox">
              <input class="form-control" type="text" placeholder="请输入详细地址"/>
            </div>
          </div>
        </div>

        <!-- 所属类型 -->
       <!--  <div class="group group-selmul" v-if="item.field_type =='selectmul'" :is_require="item.is_require" :name="item.name">
          <Cascader :item_data="item"  @change="casChange" />
        </div> -->
        <!-- 所属类型 -->
        <div class="group group-selmul content-block" v-if="item.field_type == 'selectmul'" :is_require="item.is_require" :name="item.name">
          <label>{{item.title}}<span v-show="item.is_require == 1">*</span></label>
          <Selectmul  :item_data="item" @change="casChange"></Selectmul>
        </div>
        <!--上传视频-->
        <!-- v-show="JSON.parse(UpFile).name == 'uploadvideo'"-->
        <!--  上传图片-->
        <!-- v-show="JSON.parse(UpFile).field_type == 'uploadimg'"-->

        <Upload v-if="item.field_type == 'upload' && thirdParty" :UpFile="item" type="0" :appId="appId"  :audit_level="audit_level"></Upload>

        <VideoUpload v-if="item.field_type == 'uploadvideo' && thirdParty" :UpFile="item" type="0"
                     :appId="appId" :audit_level="audit_level"></VideoUpload>

        <ImageUpload v-if="item.field_type == 'uploadimg' && thirdParty" :UpFile="item" type="0"
                     :appId="appId" :id="paramsId" :audit_level="audit_level"></ImageUpload>

        <!--上传文档-->
        <!-- v-if="UpFile" v-show="JSON.parse(UpFile).field_type == 'uploadfile'" -->
        <FileUpload v-if="item.field_type == 'uploadfile' && thirdParty" :UpFile="item" type="0"
                    :appId="appId" :id="paramsId" :audit_level="audit_level"></FileUpload>  

      </div>

    </div>

    <div v-if="!detailsTxte||!detailsTxte.page_config||!detailsTxte.page_config.notice||detailsTxte.page_config.notice.is_show!='3'" class="et-deal">
      <div class="et-deal-check et-deal-on" @click="ReadAndAgree">
        <input type="checkbox" name="checkdeal"/>
      </div>

      <p v-if="detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.notice&&detailsTxte.page_config.notice.is_show=='2'">
        {{detailsTxte.page_config.notice.text}}
      </p>
       <p v-else>
        阅读并同意<a href="javascript:void(0);" @click="agreement(1)">央视网网络服务使用协议</a>和<a href="javascript:void(0);" @click="agreement(2)">网站声明</a><span v-if="paramsId == 57722">以及<a  href="javascript:void(0);" class="chengnuo" id="chengnuo" @click="agreement(3)">报名承诺书</a></span><span v-if="detailsTxte && detailsTxte.page_config.notice && detailsTxte.page_config.notice.is_show==1">以及<a  :href="detailsTxte.page_config.notice.url" class="chengnuo" target="_blank">{{detailsTxte.page_config.notice.title}}</a></span>
      </p>
    </div>

    <a href="javascript:void(0);" :class="['et-complete',loading? 'bg_grey': '']" @click="complete" v-if="etComplete&&detailsTxte&&detailsTxte.page_config&&detailsTxte.page_config.formSubmitBtn&&detailsTxte.page_config.formSubmitBtn.is_show=='1'" v-bind:style="'background:'+detailsTxte.page_config.formSubmitBtn.style">
     {{detailsTxte.page_config.formSubmitBtn.title}}
    </a>
    <a href="javascript:void(0);" v-else="etComplete" :class="['et-complete',loading? 'bg_grey': '']" @click="complete">
      提 交
    </a>

    <!--提示-->
    <div class="sing-modal upload-modal large-info-modal modal fade" id="participateIn" role="dialog"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-body">
            <p id="fileMessage" class="Prompt-p">请确定信息是否填写完成？ </p>
            <div class="btn-modal-tw">
              <a href="javascript:void(0);" class="buttonZ" data-dismiss="modal">确定</a>
            </div>
          </div>

        </div>
      </div>
    </div>
    <div class="modal-confim large-info-modal modal fade" id="agreement" role="dialog" aria-hidden="true">
      <div class="modal-dialog" role="document" style="margin-top: 0;">
        <div class="modal-content" style="height: 450px;padding-bottom: 20px;">
          <div class="modal-body" style="height: 430px;">
            <!-- 内容部分 -->

            <div id="page_body">
              <div class="main">
                <div class="yonghuzhongxin10764A_ind16" style="position: relative">
                  <div style="height:20px;"></div>
                  <h3 class="h3_1" style="font-weight:bold;" v-if="agreement1">央视网网络服务使用协议</h3>
                  <h3 class="h3_1" style="font-weight:bold;" v-if="agreement2">网站声明</h3>
                  <h3 class="h3_1" style="font-weight:bold;" v-if="agreement3">报名承诺书</h3>
                  <div class="login_Quick" style="float: right;position: relative">
                    <a data-dismiss="modal" href="javascript:void(0);" class="icon-out" style="top: -50px"></a>
                  </div>
                  <div style="height:20px;"></div>
                  <div class="niticeSroll"
                       style="margin: 0 5px;height: 350px;overflow-y: auto;padding-top:15px; padding-bottom:15px; background:#fff; border-top:1px solid #e0e0e0; border-bottom:1px solid #e0e0e0;">
                    <div v-if="agreement1" class="ind16_main" id="jsSroll">
                      <div class="vspace"></div>
                      <h3 class="h3_2">第一章 服务使用协议的确认和接纳</h3>
                      <div class="vspace"></div>
                      <p>第一条
                        央视网网络服务使用协议（以下简称“协议”）是由用户（您）与央视国际网络有限公司（央视网）就央视网提供的网络服务所订立的相关权利义务规范，本协议对您及央视网均具有法律效力，未成年人需在法定监护人的陪同下审阅。</p>
                      <p>第二条 央视网（网址：www.cctv.com、
                        www.cntv.cn）完全按照其发布的服务条款和操作规则向用户提供服务。本协议所称的用户（您）是指完全同意所有协议条款并完成注册程序或未经注册而使用央视网提供各项服务的个人或机构。</p>
                      <p>第三条 您同意接受本协议，方可注册成为央视网正式用户。您注册成功后，央视网将给予您一个帐号及相应的密码，该帐号和密码由您负责保管；您对以该帐号进行的所有活动和事件负法律责任。</p>
                      <p>第四条 您注册前，请认真阅读本协议。注册成功后，即视为同意接受本协议的全部内容，受本协议的约束。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第二章 服务使用协议的变更和修改</h3>
                      <div class="vspace"></div>
                      <p>第五条 本协议的订立、执行、解释及争议的解决均应遵守中华人民共和国有关法律、法规，如协议之任何一部分与中华人民共和国法律、法规相抵触，则该部分条款应按法律规定执行。</p>
                      <p>第六条 央视网有权随时修改本协议的任何条款，并在央视网上公示，而无需另行单独通知您，您可随时通过央视网浏览最新服务使用协议条款。</p>
                      <p>第七条 当您使用央视网的特殊服务时，应接受央视网随时提供的与该特殊服务相关的规则或说明，并且此规则或说明均构成本协议的一部分。</p>
                      <p>第八条 如果不同意央视网对本协议相关条款所做的修改，您可以主动向客服要求取消已经获得的网络服务；如果您继续使用网络服务，则视为您接受央视网对本协议相关条款所做的修改。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第三章 服务说明</h3>
                      <div class="vspace"></div>
                      <p>第九条
                        央视网网络服务的具体内容由央视网根据实际情况提供，包括论坛（BBS）、博客、微博、播客、跟帖评论、边看边聊、邮箱、搜索等。除非另有明确规定，增强或强化目前服务的任何新功能，包括新产品，均无条件地适用本协议。</p>
                      <p>第十条 您接受本协议，须同意并提供完整、真实、准确、最新的身份信息，并不断更新注册资料。</p>
                      <p>
                        若您提供任何错误、不实、过时或不完整的身份信息，并为央视网所确知；或者央视网有合理理由怀疑前述信息为错误、不实、过时或不完整，央视网有权暂停或终止您的帐号权限，并拒绝现在或将来向您提供本服务的全部或一部分。</p>
                      <p>第十一条
                        您理解：央视网仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均由您自行负担。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第四章 您应遵守以下法律及法规</h3>
                      <div class="vspace"></div>
                      <p>第十二条 您承诺遵守中华人民共和国有关法律法规和规范性文件，承担一切因您的行为直接或间接引起的法律责任。</p>
                      <p>第十三条 您也应了解国际互联网的无国界性，还应特别注意遵守所在国家和地区所有有关的法律和法规。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第五章 使用规则</h3>
                      <div class="vspace"></div>
                      <p>第十四条
                        您要注意保管好帐号及密码，不应将您的帐号、密码转让或出借给他人使用。如您发现帐号遭他人非法使用，应立即联系央视网客服中心。因黑客行为或您保管疏忽导致帐号、密码遭他人非法使用，央视网不承担任何责任。</p>
                      <p>第十五条
                        您同意央视网有权在提供网络服务过程中以各种方式投放各种商业性广告或其他任何类型的商业信息（包括但不限于在央视网的任何传播形式上投放广告），并且，您同意接受央视网通过电子邮件或其他方式向您发送商品促销或其他相关商业信息。</p>
                      <p>第十六条
                        对于您通过央视网网络服务（包括但不限于论坛、博客、微博、播客、跟帖评论）上传到央视网上可公开获取区域的任何内容，您同意央视网在全世界范围内具有免费的、永久性的、不可撤销的、非独家的和完全再许可的下述权利：以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示此等内容（整体或部分），和/或将此等内容编入当前已知的或以后开发的其他任何形式的作品、媒体或技术中。</p>
                      <p>第十七条 您在使用央视网服务过程中，必须遵循以下原则：</p>
                      <p>(一) 遵守所有与网络服务有关的网络协议、规定和程序；</p>
                      <p>(二) 不得为任何非法目的而使用网络服务系统；</p>
                      <p>(三) 不得以任何形式使用央视网的网络服务侵犯央视网的商业利益，包括并不限于发布非经央视网许可的商业广告；</p>
                      <p>(四) 不得利用央视网的网络服务系统进行任何可能对互联网或移动网正常运转造成不利影响的行为；</p>
                      <p>(五) 不得利用央视网的网络服务功能传播任何具有欺诈、胁迫、淫秽性的和损害他人人格尊严的信息资料；</p>
                      <p>(六) 不得侵犯其他任何第三方的专利权、著作权、商标权、名誉权或其他任何合法权益；</p>
                      <p>(七) 不得利用央视网的网络服务系统进行任何不利于央视网的行为。</p>
                      <p>第十八条 您在使用央视网所提供的网络服务时，不得产生下列信息：</p>
                      <p>(一) 违反宪法或法律法规规定的；</p>
                      <p>(二) 危害国家安全，泄露国家秘密，颠覆国家政权，破坏国家统一的；</p>
                      <p>(三) 损害国家荣誉和利益的，损害公共利益的；</p>
                      <p>(四) 煽动民族仇恨、民族歧视，破坏民族团结的；</p>
                      <p>(五) 破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
                      <p>(六) 散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
                      <p>(七) 散布淫秽、色情、赌博、暴力、凶杀、恐怖或者教唆犯罪的；</p>
                      <p>(八) 侮辱或者诽谤他人，侵害他人合法权益的；</p>
                      <p>(九) 含有法律、行政法规禁止的其他内容的。</p>
                      <p>第十九条
                        您在设置帐号名称、头像和简介等注册信息时须遵守本协议第十八条的要求，不得出现违法和不良信息，并承诺遵守法律法规、社会主义制度、国家利益、公民合法权益、公共秩序、社会道德风尚和信息真实性等七条底线。</p>
                      <p>第二十条
                        央视网有权对您使用其网络服务的情况进行审查和监督（包括但不限于对您存储在央视网的内容进行审核），如您在使用网络服务时违反本协议任何规定，央视网或其授权主体有权要求您改正或直接采取一切必要的措施（包括但不限于更改或删除您已张贴的内容、暂停或终止您使用网络服务的权利等）以减轻因您的不当行为造成的影响。
                        对于违反有关法律法规、侵犯他人隐私和名誉等内容，央视网有保存相关记录，并依法向有关部门提供的权利。</p>
                      <p>第二十一条
                        央视网针对某些特定网络服务的使用通过各种方式（包括但不限于网页公告、电子邮件等）作出的任何声明、通知、警示等内容视为本协议的一部分，您如使用该等网络服务，视为您同意该等声明、通知、警示的内容。</p>
                      <p>第二十二条 您认为自己在央视网的权益受到侵害，有权根据央视网相关规定进行投诉、申诉。</p>
                      <p>第二十三条 您有权对央视网互动平台管理提出批评、意见、建议，有权就互动平台管理工作提出咨询。</p>
                      <p>第二十四条 您需遵守网络道德，注意网络礼仪，做到文明上网。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第六章 服务变更、中断或终止</h3>
                      <div class="vspace"></div>
                      <p>第二十五条 鉴于网络服务的特殊性，您同意央视网有权随时变更、中断或终止部分或全部的网络服务。</p>
                      <p>第二十六条
                        您理解：央视网需要定期或不定期地对提供网络服务的平台（如互联网网站、移动网络等）或相关的设备进行检修或者维护，如因此类情况而造成收费网络服务在合理时间内的中断，央视网无需为此承担任何责任，但应通过央视网尽可能事先进行通告。</p>
                      <p>第二十七条 如发生下列任何一种情形，央视网有权随时中断或终止向您提供本协议项下的网络服务而无需对您或任何第三方承担任何责任：</p>
                      <p>(一) 在任何情况下，央视网合理地认为您的行为可能违反中华人民共和国有关法律法规和规范性文件；</p>
                      <p>(二) 您提供的个人资料不真实；</p>
                      <p>(三) 您违反本协议中的部分条款。</p>
                      <p>第二十八条 您的帐号和密码遭到未授权的使用或发生其他任何安全问题，您可以立即通知央视网。在您每次连线结束时，应结束帐号使用，否则您可能得不到央视网的安全保护。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第七章 知识产权</h3>
                      <div class="vspace"></div>
                      <p>第二十九条
                        央视网提供的网络服务中包含的任何文本、图片、图形、音频和/或视频资料均受版权、商标和/或其它财产所有权法律的保护，未经相关权利人同意，上述资料均不得在任何媒体直接或间接发布、播放、出于播放或发布目的而改写或再发行，或者被用于其他任何商业目的。所有这些资料或资料的任何部分仅可作为私人和非商业用途而保存在某台计算机内。央视网不就由上述资料产生或在传送或递交全部或部分上述资料过程中产生的延误、不准确、错误和遗漏或从中产生或由此产生的任何损害赔偿，以任何形式，向您或任何第三方负责。</p>
                      <p>第三十条
                        央视网为提供网络服务而使用的任何软件（包括但不限于软件中所含的任何图像、照片、动画、录像、录音、音乐、文字和附加程序、随附的帮助材料）的一切权利均属于该软件的著作权人，未经该软件的著作权人许可，您不得对该软件进行反向工程（reverse
                        engineer）、反向编译（decompile）或反汇编（disassemble）。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第八章 隐私权保护</h3>
                      <div class="vspace"></div>
                      <p>第三十一条 保护用户隐私是央视网的一项基本政策，央视网保证不对外公开或向第三方提供您的注册资料及您在使用网络服务时存储在央视网的非公开内容，但下列情况除外：</p>
                      <p>(一) 事先获得您的明确授权。</p>
                      <p>(二) 依据有关法律规定，国家有关机关按照法律程序要求查询时，提供您的注册信息、您在央视网上发布的信息内容及其发布时间、互联网地址或者域名。</p>
                      <p>(三) 为维护用户及社会公共利益的需要。</p>
                      <p>(四) 为维护央视网的合法权益。</p>
                      <p>第三十二条 央视网可能会与第三方合作向您提供相关的网络服务，在此情况下，如该第三方同意承担与央视网同等的保护用户隐私的责任，则央视网有权将您的注册资料等提供给该第三方。</p>
                      <p>第三十三条 在不透露您的隐私资料前提下，央视网有权对整个用户数据库进行分析并对用户数据库进行商业上的利用。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第九章 免责声明</h3>
                      <div class="vspace"></div>
                      <p>第三十四条 您明确同意您在使用央视网网络服务所存在的风险将完全由您自己承担；因您使用央视网网络服务而产生的一切后果也由您自己承担，央视网对您不承担任何责任。</p>
                      <p>第三十五条 您对央视网提供的网络服务承担使用风险。央视网不保证服务一定会满足您的使用要求，也不保证服务不会中断，央视网对服务的及时性、安全性、准确性也不作担保。</p>
                      <p>第三十六条 央视网不保证为向您提供便利而设置的外部链接的准确性和完整性，同时，对于该等外部链接指向的不由央视网实际控制的任何网页上的内容，央视网不承担任何责任。</p>
                      <p>第三十七条 对于因不可抗力或央视网不能控制的原因造成的网络服务中断或其它缺陷，央视网不承担任何责任，但将尽力减少由此给您造成的损失和影响。</p>
                      <p>第三十八条 您同意：对于央视网向您提供的下列产品或者服务的质量缺陷引发的任何损失，央视网无需承担任何责任：</p>
                      <p>(一)央视网向您免费提供的各项网络服务；</p>
                      <p>(二)央视网向您赠送的任何产品或者服务；</p>
                      <p>(三)央视网向收费网络服务用户附赠的各种产品或者服务。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第十章 违约赔偿</h3>
                      <div class="vspace"></div>
                      <p>第三十九条 如因央视网违反有关法律、法规或本协议项下的任何条款而给您造成损失，央视网同意承担由此造成的损害赔偿责任。</p>
                      <p>第四十条 您同意保障和维护央视网及其他用户的利益，如因您违反有关法律、法规或本协议项下的任何条款而给央视网或任何其他第三人造成损失，您同意承担由此造成的损害赔偿责任。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第十一章 通知送达</h3>
                      <div class="vspace"></div>
                      <p>第四十一条 本协议项下央视网对您的所有通知均可通过网页公告、电子邮件、手机短信或常规的信件传送等方式进行；该等通知于发送之日视为已送达收件人。</p>
                      <p>第四十二条 您对于央视网的通知应当通过央视网对外正式公布的通信地址、传真号码、电子邮件地址等联系信息进行送达。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第十二章 争议解决方式</h3>
                      <div class="vspace"></div>
                      <p>第四十三条 本协议及其修订本的有效性、履行和与本协议及其修订本效力有关的所有事宜，将受中华人民共和国法律管辖，任何争议仅适用中华人民共和国法律。</p>
                      <p>第四十四条 因本协议所引起的您与央视网的任何纠纷或争议，首先应友好协商解决，协商不成的，您在此完全同意将纠纷或争议提交央视网所在地即北京市有管辖权的人民法院诉讼解决。</p>
                      <div class="vspace"></div>
                      <h3 class="h3_2">第十三章 其他规定</h3>
                      <div class="vspace"></div>
                      <p>第四十五条 本协议构成双方对本协议之约定事项及其他有关事宜的完整协议，除本协议规定的之外，未赋予本协议各方其他权利。</p>
                      <p>第四十六条 如本协议中的任何条款无论因何种原因完全或部分无效或不具有执行力，本协议的其余条款仍应有效并且有约束力。</p>
                      <p>第四十七条 本协议将取代您先前与央视网签署的任何网络服务使用协议。本协议和央视网的其他服务条款构成完整的协议。</p>
                      <p>第四十八条 本协议中的标题仅为方便而设，在解释本协议时应被忽略。</p>
                      <p>第四十九条 本协议最终解释权归央视国际网络有限公司所有 。</p>
                    </div>
                    <div v-if="agreement2" class="ind16_main" id="jsSrolls">
                      <p>央视网（www.cctv.com）和中国网络电视台（www.cntv.cn）（以下统称“本网”）由央视国际网络有限公司主办。<br>

                        　　本网是中央电视台的新媒体业务平台。经中央电视台授权，本网独占性通过信息网络向公众传播中央电视台享有著作权及相关权利的电视频道及其所包含的全部电视节目。<br>

                        　　本网所呈现的所有内容，包括但不限于文字、图像、图片、照片、图表、音频、视频、标志、标识、广告、商标、商号、域名、程序、版面设计、专栏目录与名称、内容分类标准以及为注册用户提供的任何信息，均受到《中华人民共和国著作权法》、《中华人民共和国商标法》、《中华人民共和国专利法》、《中华人民共和国反不正当竞争法》等相关法律法规的保护，为本网或权利人所有。
                        <br>
                        　　任何第三方不得歪曲和篡改本网所呈现的内容。未经本网授权，任何第三方不得擅自引用、复制、转载、摘编或以其他任何方式非法使用本网站所呈现的内容。
                        <br>
                        　　任何第三方不得擅自转载本网提供的信息和服务内容，如需转载，必须取得相应权利人的合法授权。经本网授权使用的，不得超越所获授权范围，且在转载时须保留原有信息和服务内容的来源。
                        <br>
                        　　任何第三方不得盗用本网名义发布信息，或擅自使用本网名义引用、转载来源不规范或权属不明晰的信息。
                        <br>
                        　　凡本网注明“来源：央视网／中国网络电视台”的所有内容，均为本网合法拥有著作权或相关权利的内容，未经本网授权，任何第三方不得转载、链接、摘编或以其他方式使用上述内容。已经本网授权使用的，应在授权范围内使用，并注明“来源：央视网／中国网络电视台”。
                        <br>
                        　　凡本网未标有“来源：央视网／中国网络电视台”的内容，均为转载稿，转载目的在于传递更多信息，并不代表本网赞同其观点或对其真实性负责。任何第三方在以转载、链接、摘编或者下载等方式使用时，必须保留本网注明的“来源”，并自行承担相关法律责任。
                        <br>
                        　　对于违反上述规定侵犯本网站知识产权等合法权益的行为，本网将依法追究其法律责任。
                        <br>
                        　　鉴于本网呈现的内容来源广泛、数量较多，如著作权人发现本网转载了其拥有著作权的作品且没有事先与著作权人沟通联络，请主动与本网联系，提供相关证明材料，本网将依法处理。如权利人认为本网呈现的内容侵犯其肖像权、名誉权或其他合法权益的，请主动与本网联系，提供相关投诉材料，本网亦将依法处理。
                        <br>
                        　　本网联系电话：010-88047123。<br>
                        　　
                      </p>
                    </div>
                    <div v-if="agreement3" class="ind16_main">
                      <p style="text-align: right;">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 合同编号：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; <br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 参赛者姓名：&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</p>
                      <p style="text-indent: 2em;">参赛者在报名前必须仔细阅读如下法律文本，在了解并理解的基础上承诺并签署，报名即意味着遵守法律文本中的条款，否则报名无效。</p>
                      <p style="text-indent: 2em;">一．参赛资格<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1参赛者须为中国公民。18岁以下的参赛者应在父母或监护人的许可下报名。参赛者应准确、如实、完整地填写一份个人背景资料，并确保自己在生理或心理上处于良好状况，并由本人或监护人在该资料上签字确认。如果参赛者的任何信息被查证失实，参赛者丧失参赛资格，制作方保留追究法律责任的权力；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2参赛者须具备如下资质：a 参赛者承诺是该项发明的发明人或专利权人；b 如果是该发明是共同发明。参赛者承诺其参赛行为已经获得其他所有发明人或专利权人的许可；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3鉴于“我爱发明”栏目作为电视媒体，故对参赛者提供的个人资料及发明的权利归属做实质审查不具有可行性，因此参赛者应保证其展示的发明不存在任何权利瑕疵和争议，自行承担侵犯专利权、名誉权、商业秘密等可能法律后果并保证“我爱发明”栏目不会因此受到任何诉讼和追索。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4参赛者必须提供10分钟的视频资料，其内容是发明人对自己发明项目的功能、原理、特点和使用效果的介绍。制作格式为DVD光盘。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5参赛者如有多个发明项目想申请展示，每一项目需单独填写一张项目表。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 6参赛者必须配合制作单位的安排，包括宣传、摄制等活动。对于进入节目录制环节的参赛者，必须保证按照节目录制的日程进行录制，否则制作方有权取消其录制资格。无正当理由退出或做出有损节目的行为，制作方将保留追究法律责任的权力；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 7未经制作方许可，参赛者承诺不在“我爱发明”电视制作和播放期内参加其他与该发明有关的“电视评选比赛”活动、参与或签署任何商业或赞助条款或安排、出席或参与任何不是制作单位的出镜或媒体采访活动。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 8参赛者承诺其个人及家属朋友是自愿参与“我爱发明”的节目录制，不涉及任何节目录制酬劳。节目录制期间有任何意外均由本人自行负责。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 9即使参赛者满足所有申请要求，节目制作方没有必须面试或者选择其参赛的义务；参赛者将不会因签署这份承诺书并让渡这些权利而获得任何货币收入；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 10参赛者同意并完全理解节目规程，并愿意遵守所有与之相关的规则，承担因违反此规则所产生的后果；</p>
                      <p style="text-indent: 2em; display: block;">二．发明的参赛资格<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1 该发明必须是新颖性、实用性和创造性的产品或方法，具有良好的市场前景。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2 自面试的时起至该节目录制结束，发明人[和/或]专利权人不得在此期间自行或许可他人大量生产。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3 呈交的发明必须附上完整的发明产品表格，详细的描述，必须能提供可操作或能实际应用的原型或样品。仅有概念设计的发明，将不被栏目组采用。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 4若该发明已申请专利，已公开技术文件[和/或]已取得专利权证书。发明人应向栏目组提交一份发明专利证书的复印件或相关证明文件。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 5下列类别的发明将不被栏目组接受：<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 药品、食品和保健品；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 农作物；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 医用器械；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 危险化学品或材料；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 电脑软件；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 爆破装置；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 成人用品；<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 以及其他有可能危及公共安全或引发不良影响的发明。</p>
                      <p style="text-indent: 2em; display: block;">三．“我爱发明”节目制作<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 1&nbsp; 参赛者了解并同意自报名生效之日起，中央电视台有权无偿并不须本人另行同意对本人基于参赛行为[包括但不限于：报名、各场次比赛录制等阶段]填写的资料、提供的DVD视频、节目彩排、录制过程中所产生的包含本人及发明的资料、名称、肖像、声音等的照片、图片、动画、视音频等资料在“我爱发明”节目中使用。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 2“我爱发明”电视节目的版权归中央电视台所有，中央电视台有权在无需另外付费的前提下使用该节目或节目片断。使用方式包括但不限于：各频道各种传播方式的国内外电视播放,将节目重新编辑后电视播放，素材使用，出版发行VCD、DVD 、CD等载体的音像制品，基于互联网、移动终端、IPTV、公共视频载体等新媒体平台上的信息网络传播权，出版发行基于电视节目的图书、画册、挂历、连环画等文字或文字加图片的出版物，在报纸、杂志上刊发基于电视节目的文字内容、图片，声音广播等。<br>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 3&nbsp;&nbsp; 中央电视台有权录制播出或直播选手面试、淘汰赛、决赛阶段的实况，参赛者不得对电视台播出、使用电视节目的方式进行任何干涉。</p>
                      <p style="display: block;">&nbsp;</p>
                      <p style="display: block;margin:0;line-height:1.5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 承诺人： <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 身份证号：</p>
                      <p style="display: block;margin:0;line-height:1.5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 监护人： <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 身份证号：</p>
                      <p style="display: block;margin:0;line-height:1.5">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 发明名称： <br/>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 日&nbsp;&nbsp;&nbsp; 期：</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import Upload from '../UploadToken/upload.vue'
  import FileUpload from '../UploadToken/FileUpload.vue'
  import VideoUpload from '../UploadToken/VideoUpload.vue'
  import ImageUpload from '../UploadToken/imageUpload.vue'
  import Linkage from "../template/linkage.vue"
  // import Cascader from '../template/cascader.vue'
  import Selectmul from '../template/selectmul.vue'

  export default {
    props: [
      'detailsTxte',
      // 'audit_level'
    ],
    data() {
     // console.log("data:" );
      // console.log(this.detailsTxte);
      // console.log(that.detailsTxte);
    //  console.log(that.audit_level);
      return {
        userId: "",
        RegistrationForm: "",
        _Activity: "",
        setName: "",  //性别
        UpFile: null,  //上传需求
        region: "",
        agreement1: true,
        agreement2: false,
        agreement3: false,
        appId: "mp0qftl9iu",
        audit_level: 2,
        thirdParty: true,
        etComplete: false,
        paramsId: '',
        loading: false,
        casVal: {},
        // detailsTxte: this.detailsTxte
      }
    }
    ,
    methods: {
      //操作按钮事件"
      listenToMyBoy(somedata) {
        this.region = somedata
      },
      agreement(val) {
        this.agreement1 = this.agreement2 = this.agreement3 = false;
        if (val == 1) {
          this.agreement1 = true;
        } else if(val ==2){
          this.agreement2 = true;
        } else if(val == 3){
          this.agreement3 = true;
        }
        $('#agreement').modal('show');
        $('.niticeSroll').stop().animate({scrollTop: '0'}, 200);
      },
      sexOn(ind, val, item) {
        // console.log(ind)
        this.setName = val;
        $('.' + item).eq(ind).parent().siblings().children('.' + item).removeClass('radio-on');
        $('.' + item).eq(ind).parents('li').siblings().find('.' + item).removeClass('radio-on');
        $('.' + item).eq(ind).addClass('radio-on')
      }
      ,
      SmallFocus(ind) {  //小输入框获取焦点时
        //console.log(ind)
        $('.group').eq(ind).find('input').next('.icon-delete').show();
      },
      SmallKeyup(event, ruleType, is_require) {
        if (ruleType != '' && ruleType) {
          var itself = event.target,
            val = $(itself).val(),
            itselfs = '//' + ruleType + '//',
            re = itselfs.replace(/\/\//g, "\/"),
            reg = eval(re);
          if (is_require == 0 && val == '') {
            $(itself).next().hide();
            $('.et-complete').css('pointer-events', 'visible');
          } else {
            if (!reg.test(val)) {
              $(itself).next().show();
              $('.et-complete').css('pointer-events', 'none');
              return false;
            } else {
              $(itself).next().hide();
              $('.et-complete').css('pointer-events', 'visible');
            }
          }

        }

      },
      SmallBlur(event, ind) {  //小输入框失去焦点时
        setTimeout(function () {
          $('.group').eq(ind).find('.icon-delete').hide()
        }, 200)
      },
      SmallDelete(ind) { //小输入框删除
        $('.group').eq(ind).find('input').val(' ');
        $('.icon-delete').hide();
      },
      largeDelete() {   //文本输入框删除按钮
        $('.icon-delete').parent('.et-trbox').find('textarea').val(' ');
        $('.icon-delete').hide();
      },

      ReadAndAgree() {   //阅读并同意
        if ($('.et-deal-check').hasClass('et-deal-on')) {
          $('.et-deal-check').removeClass('et-deal-on');
        } else {
          $('.et-deal-check').addClass('et-deal-on');
        }
      },
      complete() {   //完成参与

        var that = this;
        if(that.loading){ return} //加载中
        if ($('.et-complete').html() == '请先登录') {
          $('#login_Alert').modal('show');
          return false;
        }
        var file_id = {},
          fileName = $('.load-inner').find('.fileName'),
          that = this,
          content = {};
        //text文本
        var Text = $('.et-typeText');
        for (var t = 0; t < Text.length; t++) {
          //查找每一项
          var TextName = Text.eq(t).find('input');
          //判断是否必填
          if (TextName.attr('is_require') == 1) {
            if (TextName.val() == '') {
              TextName.focus();
              return false;
            }
            if (TextName.attr('name') == 'email') {
              var email = TextName.val();
              var reg = /^[a-z0-9]+([._\\-]*[a-z0-9])*@([a-z0-9]+[-a-z0-9]*[a-z0-9]+.){1,63}[a-z0-9]+$/;
              if (reg.test(email)) {

              } else {
                TextName.focus();
                return false;
              }
            }
          }
          content[TextName.attr('name')] = TextName.val()
        }
        //多行文本
        var Textarea = $('.et-trbox');
        for (var te = 0; te < Textarea.length; te++) {
          //查找每一项
          var TextareaName = Textarea.eq(te).find('textarea');
          //判断是否为必填
          if (TextareaName.attr('is_require') == 1) {
            if (TextareaName.val() == '') {
              TextareaName.focus();
              return false;
            }
          }
          content[TextareaName.attr('name')] = TextareaName.val()
        }
        //单选
        var radio = $('.et-radiolink');
        for (var r = 0; r < radio.length; r++) {
          //查找每一项
          var radioName = radio.eq(r).find('.radio-on');
          //判断是否为必填
          if (radio.eq(r).find('.radio-box').attr('is_require') == 1) {
            if (radioName.length == 0) {
              var offset = $('.et-radiolink').eq(r).offset().top;
              $('.et-radiolink').eq(r).addClass('font');
              $(window).scrollTop(offset - 200);
              return false;
            }
          }
          content[radioName.attr('name')] = radioName.next().html()
        }
        //多选
        var checked = $('.et-checklink');
        for (var c = 0; c < checked.length; c++) {
          var che = [];
          //判断是否为必填
          if (checked.eq(c).attr('is_require') == 1) {
            //是否选中
            if (checked.eq(c).find('.check-on').length == 0) {
              var offChecked = $('.et-checklink').eq(c).offset().top;
              $('.et-checklink').eq(c).addClass('font');
              $(window).scrollTop(offChecked - 200);
              return false;
            }
          }
          //遍历多选内容
          for (var cc = 0; cc < checked.eq(c).find('.check-on').length; cc++) {
            che.push($(checked.eq(c).find('.check-on')[cc]).next().html())
          }
          content[checked.eq(c).attr('name')] = JSON.stringify(che)
        }
        //下拉框
        var Select = $('.et-slebox');
        for (var s = 0; s < Select.length; s++) {
          var selectName = Select.eq(s).find('select');
          if (selectName.attr('is_require') == 1) {
            if (selectName.val() == '') {
              selectName.focus();
              return false;
            }
          }
          content[selectName.attr('name')] = selectName.val()
        }
        //日期
        var typeData = $('.et-typeData');
        for (var t = 0; t < typeData.length; t++) {
          var typeDateName = typeData.eq(t).find('input').eq(0);
          if (typeDateName.attr('is_require') == 1) {
            if (typeDateName.val() == '') {
              var etSlebox = $('.et-slebox').eq(c).offset().top;
              $('.et-slebox').eq(c).addClass('font');
              $(window).scrollTop(etSlebox - 200);
              return false;
            }
          }
          content[typeDateName.attr('name')] = typeDateName.val();
        }
        //地区
        var demolName = $('.demo1');
        if (demolName.length > 0) {
          for (var i = 0; i < demolName.length; i++) {
            var sel = $('.example').eq(i).find('select'),
              selName = '';
            for (var v = 0; v < 3; v++) {
              if (sel.eq(v).val() == '请选择') {
                var etSlebox = $('.content-block').offset().top;
                $('.example').addClass('font');
                $(window).scrollTop(etSlebox);
                return false;
              }
              if (sel.eq(v).length) {
                selName += sel.eq(v).val() + ',';
              } else {
                selName += '--' + ','
              }
            }
            if (demolName.attr('is_require') == 1) {
              if ($('.detailed').find('input').val() == '') {
                $('#Alert').find('.Prompt-p').html('请填写详细地址');
                $('#Alert').modal('show');
                $('.example').addClass('font');
                return false;
              }
            }
            selName += $('.detailed').find('input').val();
            content[demolName.eq(i).attr('name')] = selName;
          }
        }
        // 所属类型
        var selmul = $('.group-selmul');
        // if(selmul.length>0){
        // debugger;
        for(let i=0; i<selmul.length; i++){
          let seli = selmul.eq(i);
          let name = seli.attr('name');
          let casVal  = that.casVal[name];

          if(seli.attr('is_require') == 1){
            // console.log(2)
            if(!casVal || casVal[0] =='' || casVal[1]==''){
             var top = seli.offset().top;
              seli.find('.selmul').addClass('font');
              $(window).scrollTop(top);
              return false;
            }
          }
          if(casVal && casVal.length){
            content[name] = casVal.join();
          }

        }
        // }

        var uploadVideo = $('.uploadVideo');
        var uploadImg = $('.uploadImg');
        var uploadFile = $('.uploadFile');
        var uploadAll = $('.uploadAll');

        // 获取上传文件上传字段
        // if (uploadFile.attr('name')) {
        //   content[uploadFile.attr('name')] = '上传文档';
        // }
        if (uploadFile.length) {
            var fLen = uploadFile.find('.fileName')
            var fName = '';
            for (var d = 0; d < fLen.length; d++){
              fName += fLen.eq(d).attr('attr-uuid') + ','
            }
            content[uploadFile.attr('name')] = fName;
          }
        // 获取上传图片或视频
        if (uploadAll.attr('name')) {
          var allLen = uploadAll.find('.fileName')
          var allName = '';
          for (var a = 0; a < allLen.length; a++){
            allName += allLen.eq(a).attr('attr-uuid') + ','
          }
          content[uploadAll.attr('name')] = allName;
        }else{
          // 获取上传视频字段
          if (uploadVideo.length) {
            var videoLen = uploadVideo.find('.fileName')
            var videoName = '';
            for (var d = 0; d < videoLen.length; d++){
              videoName += videoLen.eq(d).attr('attr-uuid') + ','
            }
            content[uploadVideo.attr('name')] = videoName;
          }
          // 获取上传图片字段
          if (uploadImg.length) {
            var imgLen = uploadImg.find('.fileName')
            var imgName = '';
            for (var m = 0; m < imgLen.length; m++){
              imgName += imgLen.eq(m).attr('attr-uuid') + ','
            }
            content[uploadImg.attr('name')] = imgName;
          }
        }
        //判断视频是否必填
        if (uploadVideo.attr('is_require') == 1) {
          if (!$(uploadVideo).find('.videoFile').length > 0) {
            $('#Alert').find('.Prompt-p').html('请您上传视频！');
            $('#Alert').modal('show');
            return false;
          }
        }
        //判断图片是否必填
        if (uploadImg.attr('is_require') == 1) {
          if (!$(uploadImg).find('.videoFile2').length > 0) {
            $('#Alert').find('.Prompt-p').html('请您上传图片！');
            $('#Alert').modal('show');
            return false;
          }
        }
        //判断文档是否必填
        if (uploadFile.attr('is_require') == 1) {
          if (!$(uploadFile).find('.videoFile2').length > 0) {
            $('#Alert').find('.Prompt-p').html('请您上传文档！');
            $('#Alert').modal('show');
            return false;
          }
        }
        //判断图片或视频
        if (that.thirdParty) {
          if (uploadAll.attr('is_require') == 1) {
            if (!$(uploadAll).find('.videoFile').length > 0) {
              $('#Alert').find('.Prompt-p').html('请您上传图片或视频');
              $('#Alert').modal('show');
              return false;
            }
          }
        }
        //上传文件key
        for (var i = 0; i < fileName.length; i++) {
          var key = fileName.eq(i).attr('attr-uuid');
          var val = fileName.eq(i).attr('attr-type');
          file_id[key] = val
        }


        var ActivityForm = {
          activity_id: that.$route.params.id,
          //content: JSON.stringify(content),
          file_id: file_id,
          source: 1
        };

        for(var key in content){
          if(content.hasOwnProperty(key)){
            ActivityForm[key]=content[key];
          }
        }
        console.log(ActivityForm)
        if ($('.et-deal-on').length != 0) {
          $('.loading-notice').css({'top': '0', 'background': 'rgba(0,0,0,.5)'});
          $('.et-complete').addClass('dl-btn-active');
          that.loding = true
          $.ajax({
            'url': API.AddActivityForm,
            'data': ActivityForm,
            'type': 'POST',
            'dataType': 'json',
            xhrFields: {
              withCredentials: true
            },
            crossDomain: true,
            success: function (res) {
              // $('#loading').hide().removeClass('loading-notice');
              if (res.code == 0) {
                $('.et-complete').removeClass('dl-btn-active');
                $('#entryModal').modal('show');
              } else if (res.code == 3002) {
                $('#Alert').find('.Prompt-p').html('活动异常-请联系管理员！');
                $('#Alert').modal('show');
                $('.et-complete').addClass('dl-btn-active');
              } else {
                $('.et-complete').removeClass('dl-btn-active');
                $('#Alert').find('.Prompt-p').html('请确定信息是否填写完成？');
                $('#Alert').modal('show');
                //   console.log(res)
              }
            },
            complete: function(){
                that.loading = false;
            }
          })
        } else {
          alert('请选择使用协议')
        }
      },
      casChange(data){
        console.log(data);
        this.casVal[data.name] = data.value;
      }
    },

    components: {   //渲染页面
      Upload: Upload,
      ImageUpload: ImageUpload,
      FileUpload: FileUpload,
      VideoUpload: VideoUpload,
      Linkage: Linkage,
      // Cascader: Cascader,
      Selectmul: Selectmul
    },
    created: function () {
      //  console.log('notice created', detailsTxte);
      var id = this.$route.params.id,
      that = this;
      this.paramsId = id;
      if(window.isThisClient('cbox')){
        console.log("notice");
         that.cboxregisterhandler();
      }
      //账户
      if (!that.loginFn()) {
        //that.$router.push({name: 'login_Quick'});
            $('#login_Alert').modal('show');
            return false;
            console.log(that.$router,id);
            that.$router.push({name: 'login_Quick',params:{from:'/notice/'+id}});
      } else {
        // console.log('判断是否登录-已登录')
      }
     
      $('#agreement').modal('show');
      //详情

      // var detailsTxte = that.detailsTxte;
      
      // if(detailsTxte.page_config.wuxicheck && detailsTxte.page_config.wuxicheck.is_show==0){
      //     audit_level = 0;
      // }
      //  console.log("audit_level" + audit_level);
      //if(res.code == '0'){
      // if (detailsTxte.type == 1) {
      //   // that.$router.replace({name: 'Detail', params: {id: id}});
      //   that.$router.go(-1);
      // }
      // var data = new Date(detailsTxte.end_time).getTime() /*+ 86400000*/ - new Date().getTime();
      // if (data.status == 2) {
      //   $('.et-complete').addClass('dl-btn-active')
      // }
      // if (data > 0) {
      //   $('.et-complete').removeClass('dl-btn-active')
      // } else {
      //   $('.et-complete').addClass('dl-btn-active')
      // }
      // var startData = new Date(detailsTxte.start_time).getTime() - new Date().getTime();
      // if(startData > 0){
      //   // that.$router.replace({name: 'Detail', params: {id: id}});
      //   that.$router.go(-1);

      // }
      //是否参与
      that.$http.get(API.IsJoin, {params: {activity_id: id}})
        .then(function (res) {
          if (res.data.isJoin == 1) {
            // that.$router.replace({name: 'myActivity_MyParticipate', params: {id: id}});//继续参与
            that.$router.replace({name: 'Revise', params: {id: id,form_id:0}});//继续参与
            return false;
          }
        })
       this.$http.get(API.GetActivitieById, {params: {id: id}})
        .then(function (res) {
            // console.log(res,'entryform');
          if (res.code == 0) {
             that.detailsTxte = res.data;
            if(that.detailsTxte.page_config.wuxicheck && that.detailsTxte.page_config.wuxicheck.is_show==0){
                that.audit_level = 0;
            }
            console.log("notice audit_level:"+that.audit_level);
          }
        });
      //报名字段
      that.$http.get(API.GetActivityFormFields, {params: {activity_id: id}})
        .then(function (res) {
          var data = res.data
          if (res.code == 0) {
            that.$http.get(API.GetUserActivityInfo)
              .then(function (res) {
                var _data = res.data.userInfo
                var _arr = data.map(function (item, val) {
                  var name = '';
                  if (_data) {
                    name = _data[item.name]
                  }
                  return {
                    activity_id: item.activity_id,
                    name: item.name,
                    title: item.title,
                    tip: item.tip,
                    field_type: item.field_type,
                    is_require: item.is_require,
                    option_json: item.option_json || '',
                    default_value: name || '',
                    choose_num: data[val].choose_num || '',
                    rule_type: data[val].rule_type || ''
                  }
                });
                that.RegistrationForm = _arr;
                 console.log("GetActivityFormFields level:" +that.audit_level);
              })
            if (res.data.length == 0) {
              // that.$router.push({name: 'Detail', params: {id: id}});
              that.$router.go(-1);

            }
            that.$nextTick(function(){
             that.etComplete = true
            })
          } else {
            $('#login_Alert').modal('show');
            $('.et-complete').html('请先登录')
            //that.$router.push({name: 'Detail', params: {id: id}});
            console.log('报名字段-请求数据信息出错')
          }
        });

    },
    mounted: function () {
      //操作DOM
      var that = this;

      // function ready() {
      //   if (window.__wxjs_environment === 'miniprogram') {
      //     var str = navigator.userAgent.toLowerCase();
      //     var name = str.toLowerCase()
      //     var ver = name.match(/os (.*?) like/);
      //     var userName = that.getCookie('userSeqId')
      //     if (ver) {
      //       var n = ver[1].replace(/_/g, ".")
      //       var w = parseInt(n);
      //       if (w == 10 || n == "10.2.1") {
      //         that.thirdParty = false;
      //       }
      //     }
      //   }
      // }

      // if (!window.WeixinJSBridge || !WeixinJSBridge.invoke) {
      //   document.addEventListener('WeixinJSBridgeReady', ready, false)
      // } else {
      //   ready()
      // }
      //单选触发
      $('.form').on('click', '.et-radiolink', function () {
        $('.et-radiolink').removeClass('font')
      });
      $('.form').on('click', '.et-checklink', function () {
        $('.et-checklink').removeClass('font')
      });
      //选择日期
      $('.date-show').on('focus', function () {
        $('.icon-date').trigger('click');
      });
      // $('.date-show').on('oninput', function () {
      //   $('.icon-date').trigger('click');
      // });

      //文本输入框根据内容自动变高
      $('textarea').unbind('input');
      $('textarea').bind('input', function () {
        handleTextareaHeight(this);
      });

      function handleTextareaHeight(element) {
        var textareaMinHeight = 72;
        element.style.height = textareaMinHeight + 'px';
        if (element.scrollHeight > textareaMinHeight) {
          element.style.height = element.scrollHeight + 'px';
        }
      }

      // checkbok 选中函数
      $('.form').on('click', '.et-checklink li', function () {
        if ($(this).find('.check-box').hasClass('check-on')) {
          $(this).find('.check-box').removeClass('check-on');
        } else {
          $(this).find('.check-box').addClass('check-on');
        }
      });
      //当前日期
      setTimeout(function () {
        var getMonth = '',
          getDate = '';
        if (new Date().getMonth() + 1 < 10) {
          getMonth = '0' + (new Date().getMonth() / 1 + 1)
        } else {
          getMonth = new Date().getMonth() / 1 + 1
        }
        if (new Date().getDate() < 10) {
          getDate = '0' + new Date().getDate()
        } else {
          getDate = new Date().getDate()
        }
        var data = new Date().getFullYear() + '-' + getMonth + '-' + getDate;
        // $('.date-style').val(data);
        // $('.date-show').val(data);
        $('.date-new-show').val(data);
      }, 500);

      // 日期
      
      // $('.form').on('click', 'input[type ="date"]', function () {
      //   $(this).parents('.et-typeData').find('.date-show').focus();
      // });
      // $('.form').on('oninput', '.date-show', function () {
      //   $(this).next.click();
      // });
      // $('.form').on('change', 'input[type ="date"]', function () {
      //   $(this).prev('input').val($(this).val())
      // });

    }

  }

</script>

<style>
  .gearArea {
    font-family: Helvetica Neue, Helvetica, Arial, sans-serif;
    font-size: 10px;
    background-color: rgba(0, 0, 0, 0.2);
    display: block;
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 9900;
    overflow: hidden;
    -webkit-animation-fill-mode: both;
    animation-fill-mode: both
  }

  .area_ctrl {
    vertical-align: middle;
    background-color: #d5d8df;
    color: #000;
    margin: 0;
    height: auto;
    width: 100%;
    position: absolute;
    left: 0;
    bottom: 0;
    z-index: 9901;
    overflow: hidden;
    -webkit-transform: translate3d(0, 0, 0);
    transform: translate3d(0, 0, 0)
  }

  .slideInUp {
    -webkit-animation: slideInUp .3s;
    animation: slideInUp .3s;
  }

  @-webkit-keyframes slideInUp {
    from {
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0)
    }
    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0)
    }
  }

  @keyframes slideInUp {
    from {
      -webkit-transform: translate3d(0, 100%, 0);
      transform: translate3d(0, 100%, 0)
    }
    to {
      -webkit-transform: translate3d(0, 0, 0);
      transform: translate3d(0, 0, 0)
    }
  }

  .area_roll {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    width: 100%;
    height: auto;
    overflow: hidden;
    background-color: transparent;
    -webkit-mask: -webkit-gradient(linear, 0% 50%, 0% 100%, from(#debb47), to(rgba(36, 142, 36, 0)));
    /*-webkit-mask: -webkit-linear-gradient(top, #debb47 50%, rgba(36, 142, 36, 0))*/
  }

  .area_roll > div {
    font-size: 1.6em;
    height: 10em;
    float: left;
    background-color: transparent;
    position: relative;
    overflow: hidden;
    -webkit-box-flex: 1;
    -webkit-flex: 1;
    -ms-flex: 1;
    flex: 1
  }

  .area_roll > div .gear {
    width: 100%;
    float: left;
    position: absolute;
    z-index: 9902;
    margin-top: 4em
  }

  .area_roll_mask {
    -webkit-mask: -webkit-gradient(linear, 0% 40%, 0% 0%, from(#debb47), to(rgba(36, 142, 36, 0)));
    /*-webkit-mask: -webkit-linear-gradient(bottom, #debb47 50%, rgba(36, 142, 36, 0));*/
    padding: 0
  }

  .area_grid {
    position: relative;
    top: 4em;
    width: 100%;
    height: 2em;
    margin: 0;
    box-sizing: border-box;
    z-index: 0;
    border-top: 1px solid #abaeb5;
    border-bottom: 1px solid #abaeb5
  }

  .area_roll > div:nth-child(3) .area_grid > div {
    left: 42%
  }

  .area_btn {
    color: #0575f2;
    font-size: 1.6em;
    line-height: 1em;
    text-align: center;
    padding: .8em 1em
  }

  .area_btn_box:before,
  .area_btn_box:after {
    content: '';
    position: absolute;
    height: 1px;
    width: 100%;
    display: block;
    background-color: #96979b;
    z-index: 15;
    -webkit-transform: scaleY(0.33);
    transform: scaleY(0.33)
  }

  .area_btn_box {
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    -webkit-box-pack: justify;
    -webkit-justify-content: space-between;
    -ms-flex-pack: justify;
    justify-content: space-between;
    -webkit-box-align: stretch;
    -webkit-align-items: stretch;
    -ms-flex-align: stretch;
    align-items: stretch;
    background-color: #f1f2f4;
    position: relative
  }

  .area_btn_box:before {
    left: 0;
    top: 0;
    -webkit-transform-origin: 50% 20%;
    transform-origin: 50% 20%
  }

  .area_btn_box:after {
    left: 0;
    bottom: 0;
    -webkit-transform-origin: 50% 70%;
    transform-origin: 50% 70%
  }

  .tooth {
    height: 2em;
    line-height: 2em;
    text-align: center;
    display: -webkit-box;
    display: -webkit-flex;
    display: -ms-flexbox;
    display: flex;
    line-clamp: 1;
    -webkit-box-orient: vertical;
    -webkit-box-direction: normal;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    overflow: hidden
  }

  #page_body {

  }

  #page_body .ind16_main .h3_2 {
    font-size: 14px;
    font-weight: 700;
    padding: 0 15px;
  }

  #page_body .ind16_main p {
    font-size: 14px;
    padding: 0 15px;
  }
  #chengnuo{
    color: #cf5454;;
  }
  .bg_grey{
    background-color: grey;
  }
</style>



// WEBPACK FOOTER //
// src/components/entryform/notice.vue